<template>
    <page
        :id="id"
        :title="title"
        :status="page_status"
        :waiting="waiting"
        @statused="statused"
    >
        <template v-slot:title>
            <slot name="title">
                <div v-if="title" class="uk-margin-bottom lam-page-title" data-uk-sticky :style="title_style">
                    <div class="uk-container uk-container-center lam-page-main-title">
                        <h1 class="uk-grid uk-grid-small">
                            <div :class="{'uk-text-contrast': dark_background}" class="uk-width-3-5">
                                <slot name="page-title">
                                    <div class="lam-nowrap-ellipsis">{{ title }}</div>
                                </slot>
                            </div>
                            <div class="uk-width-2-5 uk-text-right lam-page-title-view">
                                <slot name="title-view"></slot>
                                <a href="#main-nav" class="uk-icon-hover uk-icon-arrow-circle-up lam-page-scroll-up" :class="{'uk-text-contrast': dark_background}" data-uk-smooth-scroll></a>
                                <slot name="main-page-actions"></slot>
                            </div>
                        </h1>
                    </div>
                    <div v-if="has_subtitle_view" class="uk-container uk-container-center lam-page-subtitle">
                        <slot name="subtitle-view"></slot>
                    </div>
                </div>
            </slot>
        </template>
        <div class="uk-container uk-container-center">
            <form class="uk-form lam-edit-screen lam-bordered-columns uk-grid uk-margin-bottom" v-if="record">
                <div v-if="$slots['right-panel']" :class="rightPanelClass">
                    <slot name="right-panel"></slot>

                    <slot name="right-panel-actions">
                        <base-button v-if="canDeleteData" size="small" width="1-1" color="danger" class="uk-margin-top uk-width-1-1" @click.prevent="remove">Delete</base-button>
                    </slot>
                </div>

                <div :class="leftPanelClass">
                    <div v-if="canEditData && record.draft_author_id" class="uk-alert uk-alert-warning" v-html="draft_warning"></div>

                    <slot name="left-panel"></slot>

                    <slot name="left-panel-actions">
                        <base-button v-if="!$slots['right-panel'] && canDeleteData" size="small" width="1-1" color="danger" class="uk-margin-top uk-width-1-1" @click.prevent="remove">Delete</base-button>
                    </slot>
                </div>
            </form>
        </div>
        <slot name="editor-footer"></slot>
    </page>
</template>

<script type="text/javascript">
import is_page from "../mixins/IsPage"
import ui_utilities from "../mixins/UiUtilities"

import BaseButton from "./BaseButton"

export default {
    mixins: [is_page, ui_utilities],
    components: {
        BaseButton
    },
    methods: {
        remove () {
            this.$emit("remove")
        }
    },
    computed: {
        draft_warning () {
            return "This record is in \"Draft\" mode, and only visible to you, its creator.<br>Fill-out all the required values (higlighted in yellow) to make it visible ot other users."
        },
        title_style () {
            if(!this.highlightColor) return ""

            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dark_background = this.is_dark_color(this.highlightColor)

            return `background-color: ${this.highlightColor};`
        },
        has_subtitle_view () {
            return !!this.$slots["subtitle-view"]
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        record: {
            required: true
        },
        title: {
            type: String,
            default: ""
        },
        canViewData: {
            default: false
        },
        canEditData: {
            default: false
        },
        canDeleteData: {
            default: false
        },
        rightPanelClass: {
            type: String,
            default: "uk-width-large-1-3 uk-width-small-1-1 uk-margin-bottom"
        },
        leftPanelClass: {
            type: String,
            default: "uk-width-large-2-3 uk-width-small-1-1 uk-margin-bottom"
        },
        highlightColor: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            dark_background: false
        }
    }
}
</script>
